import { OverlayPortal } from '@lib/components'
import { useClickOutside } from '@lib/hooks'
import { Button, ThemeColors } from '@octopus-do/octopus-storybook'
import { closeSystemDialog, openSystemDialog } from '@storeOld/reducers/ui'
import classNames from 'classnames'
import { useEffect, useRef } from 'react'
import { connect } from 'react-redux'

import DialogTypes from './types'

import './SystemDialog.css'
import { InternalConfirmActions } from '@/store'

const Dialog = ({
  onKeydown,
  onClickOutside,
  children,
  isLocked = false,
  cardClassName = '',
}) => {
  const ref = useRef(null)

  const clickOutside = useClickOutside(true, onClickOutside)

  useEffect(() => {
    function onDocumentKeydown(e) {
      if (e.which === 27) {
        onKeydown('esc')
        return
      }

      if (e.which === 13) {
        onKeydown('enter')
      }
    }

    setTimeout(() => {
      ref.current.classList.add('show')
    }, 100)

    document.addEventListener('keydown', onDocumentKeydown)

    return function close() {
      document.removeEventListener('keydown', onDocumentKeydown)
    }
  })

  return (
    <div
      className={classNames('System-dialog', {
        'System-dialog--locked': isLocked,
      })}
      ref={ref}
    >
      <div
        className={classNames('System-dialog__card', cardClassName)}
        {...clickOutside}
      >
        {children}
      </div>
    </div>
  )
}

function render(type) {
  switch (type) {
    default:
      return DialogTypes[type] || null
  }
}

const Cancel = (props) => {
  const { onClick } = props

  return (
    <Button
      className={ThemeColors.dark}
      priority="secondary"
      size="medium"
      label="Cancel"
      onClick={onClick}
    />
  )
}

const Container = ({
  dialogType,
  dialogProps,
  dialogListeners,
  closeSystemDialog,
  clearConfirm,
  submitConfirm,
}) => {
  const Component = render(dialogType)

  const onClose = () => {
    dialogProps.callback?.(false)

    document.querySelector('.System-dialog').classList.remove('show')

    setTimeout(() => {
      clearConfirm()
      closeSystemDialog()
      dialogListeners?.forEach((listener) => {
        listener(false)
      })
    }, 300)
  }

  const confirmCb = () => {
    dialogProps.callback?.(true)

    document.querySelector('.System-dialog').classList.remove('show')

    setTimeout(() => {
      closeSystemDialog()
      submitConfirm()
      dialogListeners?.forEach((listener) => {
        listener(true)
      })
    }, 300)
  }

  const handleKeyDown = (type) => {
    if (type === 'esc') {
      onClose()
      return
    }

    if (type === 'enter') {
      confirmCb()
    }
  }

  if (!Component) {
    return null
  }

  return (
    <OverlayPortal root="confirmations">
      <Dialog
        onKeydown={handleKeyDown}
        onEnterKey
        onClickOutside={onClose}
        {...dialogProps}
      >
        <Component
          cancelButton={<Cancel onClick={onClose} />}
          confirmCb={confirmCb}
          onCancel={onClose}
          {...dialogProps}
        />
      </Dialog>
    </OverlayPortal>
  )
}

const mapStateToProps = ({ ui }) => {
  return {
    dialogType: ui.dialogType,
    dialogProps: ui.dialogProps,
    dialogListeners: ui.dialogListeners,
  }
}

const mapDispatchToProps = {
  openSystemDialog,
  closeSystemDialog,
  // todo: use general dialog inside confirmation (inverse current logic), remove custom case for confirmation
  clearConfirm: InternalConfirmActions.clear,
  submitConfirm: InternalConfirmActions.submit,
}

export default connect(mapStateToProps, mapDispatchToProps)(Container)
